<div class="body">
        <h1 @fadeIn>{{'Loading' | translate}}</h1>
    <!--    <div class="center">-->
    <!--        <div class="loader"></div>-->
    <!--    </div>-->
<!--    <div class="center">-->
<!--        <img src="./assets/Gif/loading.gif">-->
<!--    </div>-->
    <div class="center">
        <mat-spinner></mat-spinner>
    </div>

</div>


